import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Container } from './styled'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import EventHeader from '../eventHeader/view'
import { joinEvent } from 'api'
import { Grid, Button } from '@mui/material'
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router'

const EventTicketSignup = ({event }) => {

  const { t } = useTranslation()
  const params = useParams()
  const { slug } = params
  const [formValid] = useState(true);

  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    name: '',
    email: '',
  })

  const [formData] = useState({
    event: slug,
  })

  const signUp = () => {

      joinEvent(formData).then(r => {
        if (r.status == 'duplicated') {
          setErrors({ ...errors, email: t('event.joinDuplicated') })
        } else {
          
          navigate(`/event-ticket/${r.ticket?.slug}`);
        }
      })
        .catch(console.error)
    }



  return (
    <Container>
      <EventHeader event={event} disclaimer={false}/>
      <Box container spacing={2}>
        
        
      </Box>
     

      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={6}>
          <Button
            variant="contained"
            color="button_color"
            onClick={() => signUp()}
            fullWidth
            disabled={!formValid}
          >Join Event
          </Button>
        </Grid>
        {/* <Grid item xs={12}>
          <Button
            variant="text"
            color="primary"
            onClick={() => setLogin(true)}
            fullWidth
          >I already have an account
          </Button>
        </Grid> */}
      </Grid>

    </Container>
  )
}

EventTicketSignup.propTypes = {
  setLogin: PropTypes.func,
  event: PropTypes.object,
}
EventTicketSignup.defaultProps = {
  setLogin: () => null,
  event: () => {},
}


export default EventTicketSignup
